<template>
  <VModal :disable-backdrop-click="pending" :disable-close="pending" @close="closeModal">
    <template #default="modalProps">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-7xl sm:w-full h-full">
        <div class="flex flex-col h-full divide-y">
          <div class="flex-none p-4">
            <div class="flex justify-between items-center">
              <div class="flex-1">Select tags to add</div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 h-0">
            <div class="h-full overflow-y-auto">
              <ul v-if="!response" class="space-y-8 p-8">
                <li v-for="group in tagsByCategory" :key="group.id" class="space-y-2">
                  <h2 class="text-sm font-medium text-gray-500">
                    {{ group.label }}
                  </h2>
                  <div class="-mx-1">
                    <BaseChipsBasic v-model="selectedTagIds" :options="group.options" multiple />
                  </div>
                </li>
              </ul>
              <div v-else>
                <template v-if="response.subscribersCount">
                  <h3 class="text-lg font-medium mb-4">Tagging has started!</h3>
                  <p>Total subscribers to process: {{ response.subscribersCount }}</p>
                  <p>This may take some time.</p>
                </template>
                <template v-else>
                  <h3 class="text-lg font-medium mb-4">No contacts found for tagging!</h3>
                  <p>Make sure selected contacts are linked to a mail marketing app.</p>
                </template>
              </div>
            </div>
          </div>
          <div class="flex-none">
            <BaseVeeForm :action="submit" @success="closeModal" class="flex-1 p-4">
              <template #default="formProps">
                <div>
                  <div class="flex space-x-2">
                    <BaseButton
                      primary
                      :disabled="selectedTagIds.length === 0 || formProps.isPending"
                    >
                      Submit
                    </BaseButton>
                    <BaseButton
                      type="button"
                      ghost
                      :disabled="formProps.isPending"
                      @click="modalProps.close"
                    >
                      Cancel
                    </BaseButton>
                  </div>
                </div>
              </template>
            </BaseVeeForm>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import { accountTagCategoriesClient, accountContactBatchTagsClient } from '@/api/clients/index';

export default {
  name: 'AddTagsDialog',
  props: {
    accountId: {
      type: String,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTagIds: [],
      tagsByCategory: [],
      pending: false,
      response: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await accountTagCategoriesClient.list(this.accountId, {
          filter: {
            taggable_by: 'contacts',
          },
          include: 'tags',
        });

        this.tagsByCategory = (response?.data || []).map((category) => ({
          id: category.id,
          label: category.name,
          options: category.tags.map((tag) => ({ value: tag.id, label: tag.name })),
        }));

        this.meta = response?.meta || null;
      } catch (error) {
        //
      }
    },
    async submit() {
      try {
        await accountContactBatchTagsClient.store(
          this.accountId,
          {
            ids: this.selectedTagIds,
          },
          this.query
        );
      } catch (error) {
        //
      }
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
